module.exports = __webpack_public_path__ + "img/fi-rr-user-add.d9818eb6.svg";